// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"32de9de8","104":"9858d566","111":"a7f30941","196":"c97e4954","413":"d5b2b6da","513":"fcd499df","583":"f104f450","607":"0f42bb09","638":"d51396c1","642":"649a1f0d","864":"7c6988fe","921":"53eade52","960":"62e98ac9","983":"a57578f9","995":"348c075f"}[chunkId] + ".chunk.js";
};